import type { ISrc, ICoverSizesByHeight, ICoverSizesByWidth } from "./types";

export const getCoverSrc = (
  artId: number,
  coverSizes: ICoverSizesByHeight | ICoverSizesByWidth
): ISrc => {
  const { desktopNormal, desktopHighDensity, mobileNormal, mobileHighDensity } =
    coverSizes;
  // для запроса картинки по высоте к размеру добавляется префикс "h" например "h270"
  const coverByHeight =
    "byHeight" in coverSizes && coverSizes.byHeight ? "h" : "";
  return {
    fallbackImage: `https://cdn.litres.ru/pub/c/cover_100/${artId}.jpg`,
    srcSetJpgMobile: `
      https://cdn.litres.ru/pub/c/cover_${coverByHeight}${mobileNormal}/${artId}.jpg,
      https://cdn.litres.ru/pub/c/cover_${coverByHeight}${mobileHighDensity}/${artId}.jpg 2x
    `,
    srcSetJpgDesktop: `
      https://cdn.litres.ru/pub/c/cover_${coverByHeight}${desktopNormal}/${artId}.jpg,
      https://cdn.litres.ru/pub/c/cover_${coverByHeight}${desktopHighDensity}/${artId}.jpg 2x
    `,
    srcSetWebpMobile: `
      https://cdn.litres.ru/pub/c/cover_${coverByHeight}${mobileNormal}/${artId}.webp,
      https://cdn.litres.ru/pub/c/cover_${coverByHeight}${mobileHighDensity}/${artId}.webp 2x
    `,
    srcSetWebpDesktop: `
      https://cdn.litres.ru/pub/c/cover_${coverByHeight}${desktopNormal}/${artId}.webp,
      https://cdn.litres.ru/pub/c/cover_${coverByHeight}${desktopHighDensity}/${artId}.webp 2x
    `,
  };
};
